// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--RNdSK","icon":"_7a3fb80146--icon--dF9uI","info":"_7a3fb80146--info--B_DNZ","message":"_7a3fb80146--message--atDlj"};